import { Menu, Row, Col, Divider, Layout } from 'antd';
import { Outlet, Link } from "react-router-dom";
import { MailOutlined, AppstoreOutlined, SettingOutlined,ContactsOutlined  } from '@ant-design/icons';
const { Header, Footer, Sider, Content } = Layout;
const M = () => {
    return(<>
    <Row><Col span={24}>
  <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['mail']}>
    <Menu.Item key="About" icon={<ContactsOutlined />}>
        <Link to="/about">About</Link>
    </Menu.Item>
    <Menu.Item key="Profile" icon={<MailOutlined />}>
     <Link to="/profile">Professional Profile</Link>
    </Menu.Item>
    <Menu.Item key="Resume" icon={<MailOutlined />}>
    <Link to="/resume">Resume</Link>
    </Menu.Item>
  </Menu>
  </Col>
  </Row>
  <Divider></Divider>
  <Layout style={{
          padding: '0 24px 24px',
        }}>
        
        <Content><Outlet /></Content>
        
  </Layout>
   
   
   </>
    )
};

export default M;